import React from 'react'

const Card = ({features , customClass}) => {
  return (
   <>
   <section className={`feature-section ${customClass}`}>
        {features.map((feature) => (
            <div className="feature-card" key={feature.id}>
            <div className="top">
                <div className="feature-icon">{feature.icon}</div>
                <h3>{feature.title}</h3>
            </div>
            <p>{feature.description}</p>
            </div>
        ))}
        </section>
   </>
  )
}

export default Card